import { FC } from "react";
import { Grid, Card, Icon, Tab } from "semantic-ui-react";
import { PricingTabProps } from "./types";

const MarketplaceAppDetailPricingTab: FC<PricingTabProps> = ({ plans }) => (
  <Tab.Pane>
    <div className="marketplace-app-detail--pricing">
      <Grid stackable doubling columns={2}>
        {plans.map((plan, index) => (
          <Grid.Column width={8} key={index}>
            <Card fluid className="support-box width-100p max-width-100p">
              <Card.Content className="support-box__content">
                <Card.Header className="support-box__title">
                  {plan.name}
                </Card.Header>
                <Card.Meta className="support-box__description">
                  {plan.description}
                </Card.Meta>
                <div className="support-box__price">
                  <h3 className="support-box__price--number">{plan.price}</h3>
                  {plan.priceDuration && (
                    <div className="support-box__disclaimer">
                      {plan.priceDuration}
                    </div>
                  )}
                </div>
                {plan.features && plan.features.length > 0 && (
                  <Card.Description>
                    <ul className="support-box__features">
                      {plan.features?.map((feature, idx) => (
                        <li key={idx} className="support-box__feature-item">
                          <Icon name="check circle" color="green" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </Card.Description>
                )}
              </Card.Content>
            </Card>
          </Grid.Column>
        ))}
      </Grid>
    </div>
  </Tab.Pane>
);

export default MarketplaceAppDetailPricingTab;
